<template>
    <transition name="modal">
        <div class="modal__mask modalRepresentantesPJ" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal_representante" style="overflow-y: auto; height: 100% !important;">
                        <a @click.stop.prevent="closeModal" class="close__modal modal-close-btn">×</a>
                        <div class="inner__modal" style="margin: 20px;">
                            <div class="sub_inner_modal" style="align-items: center; width: 100%; margin-bottom: 15px; padding-right: 30px; padding-top: 60px;">
                                <div style="min-width: 40px; margin-right: 10px;">
                                    <img style="width: 36px; height: 36px;"
                                        src="@/assets/addRepresentante.png" />
                                </div>
                                <div>
                                    <h2 style="margin: 0; font-size: 15px;">
                                        Adicionar representante</h2>
                                </div>
                            </div>
                            <form action="" class="form__class" @submit.stop.prevent="createRepresentante">
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Selecione tipo*</label>
                                        <select class="field" v-model="representante.Tipo" @change="handleTipoChange">
                                            <option value="">Selecione</option>
                                            <option value="Representante">Representante</option>
                                            <option value="Pessoa autorizada emitir ordem">Autorizado a emitir ordens
                                            </option>
                                        </select>
                                        <p v-if="camposObrigatorios.erroTipo" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Nome*</label>
                                        <input type="text" class="field" autocomplete="off" v-model="representante.Nome"
                                            @click.stop.prevent="clear" />
                                        <p v-if="camposObrigatorios.erroNome" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">{{ obterLabelDocumento }}*</label>
                                        <input type="text" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.CpfCnpj" v-mask="obterMascaraDocumento"
                                            :placeholder="obterPlaceholderDocumento" @change="validarDocumento" />
                                        <p v-if="camposObrigatorios.erroCpfCnpj" class="erro">Campo obrigatório.</p>
                                        <p v-if="erroDocumento" class="erro">{{ mensagemErro }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">E-mail*</label>
                                        <input type="text" id="email" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.Email" @blur="validarEmail" />
                                        <p v-if="emailErros.email" class="erro">{{ emailErros.email }}</p>
                                    </div>
                                </div>
                                <div class="row" v-if="exibirCargo">
                                    <div class="form__controls">
                                        <label class="label">Cargo*</label>
                                        <input type="text" id="email" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.Cargo"  />
                                        <p v-if="camposObrigatorios.cargo" class="erro">Campo obrigatório</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <telefone-internacional
                                            v-model="representante.Telefone" 
                                            label="Telefone*" 
                                            name="Telefone"
                                            @validate="onValidateTelefone"
                                        />
                                        <p v-if="camposObrigatorios.erroTelefone" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>

                                <!-- Restante do template sem alterações... -->
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="assinante">Assinatura*</label>
                                        <select id="assinante" class="field" v-model="representante.Assinatura"
                                            :disabled="representante.Tipo === 'Pessoa autorizada emitir ordem'">
                                            <option value="">Selecione</option>
                                            <option value="1">Não assina pela empresa</option>
                                            <option value="2">Assina isoladamente</option>
                                            <option value="0">Assina em conjunto</option>
                                        </select>
                                        <p v-if="camposObrigatorios.erroAssinatura" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="nome">É considerado US PERSON?*</label>
                                        <div class="radio">
                                            <input type="radio" id="false" :name="UsPerson" class="field__radio"
                                                value="false" @change="salvarAlteracoesLocalmente"
                                                v-model="representante.UsPerson" />
                                            <label for="Nao" class="label">Não</label>
                                            <input type="radio" id="true" value="true" :name="UsPerson"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente" v-model="representante.UsPerson" />
                                            <label for="Sim" class="label">Sim</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="nome">É uma Pessoa Exposta Politicamente?*</label>
                                        <div class="radio">
                                            <input type="radio" id="false" :name="PoliticamenteExposta"
                                                class="field__radio" value="false" @change="salvarAlteracoesLocalmente"
                                                v-model="representante.PoliticamenteExposta" />
                                            <label for="Nao" class="label">Não</label>
                                            <input type="radio" id="true" value="true" :name="PoliticamenteExposta"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.PoliticamenteExposta" />
                                            <label for="Sim" class="label">Sim</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-if="configuracaoResponsavelPorLogin" class="form__controls" style="width: 100%">
                                        <label class="label" for="nome">Será o responsável pelo login?*</label>
                                        <div class="radio">
                                            <input type="radio" id="false" :name="ResponsavelLogin" class="field__radio"
                                                value="false" v-model="representante.ResponsavelLogin"
                                                :disabled="representante.Tipo === 'Pessoa autorizada emitir ordem' || existeResponsavelLogin || !configuracaoResponsavelPorLogin" />
                                            <label for="Nao" class="label">Não</label>
                                            <input type="radio" id="true" value="true" :name="ResponsavelLogin"
                                                class="field__radio field__radio_second"
                                                v-model="representante.ResponsavelLogin"
                                                :disabled="representante.Tipo === 'Pessoa autorizada emitir ordem' || existeResponsavelLogin || !configuracaoResponsavelPorLogin" />
                                            <label for="Sim" class="label">Sim</label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div style="display: flex; flex-direction: row; justify-content: center; margin: 20px auto; width: 100%;">
                                    <div style="display: inline-block; margin: 0 10px;">
                                        <button v-if="!disableBtn" type="button" class="btnDefault" style="width: 135px; height: 40px;"
                                            @click="closeModal">Cancelar</button>
                                    </div>
                                    <div style="display: inline-block; margin: 0 10px;">
                                        <button v-if="!disableBtn && representante.Guid == ''" type="button" class="btnBlue" style="width: 135px; height: 40px;"
                                            @click="salvarRepresentante">Adicionar</button>
                                        <button v-else-if="!disableBtn && representante.Guid != ''" type="button" class="btnBlue" style="width: 135px; height: 40px;"
                                            @click="salvarRepresentante">Atualizar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '@/api/axios';
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import { mask } from 'vue-the-mask';
import documentoUtils from '@/utils/documentoUtils';

export default {
    directives: {
        mask
    },
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PJ_ADD_PESSOA",
            editarRepresentante: 'GET_MODAL_PJ_EDITAR_PESSOA',
            user: 'auth/user',
            existeResponsavelLogin: 'existeResponsavelLogin',
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
        celularMask() {
            const telefoneLimpo = this.representante.Telefone?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
        // Computed properties para o documento
        obterLabelDocumento() {
            if (!this.representante || !this.representante.TipoDocumento) return 'CPF';
            return documentoUtils.obterLabelDocumento(this.representante.TipoDocumento);
        },
        obterMascaraDocumento() {
            if (!this.representante || !this.representante.TipoDocumento) return '###.###.###-##';
            return documentoUtils.obterMascaraDocumento(this.representante.TipoDocumento);
        },
        obterPlaceholderDocumento() {
            if (!this.representante || !this.representante.TipoDocumento) return '000.000.000-00';
            return documentoUtils.obterPlaceholderDocumento(this.representante.TipoDocumento);
        }
    },
    mixins: [emailValidatorMixin],
    data() {
        return {
            emailErros: {},
            telefoneValido: [],
            exibirCargo: false,
            permitirAvancar: false,
            configuracaoResponsavelPorLogin: false,
            camposObrigatorios: {
                erroTipo: false,
                erroNome: false,
                erroCargo: false,
                erroCpfCnpj: false,
                erroTipoDocumento: false,
                erroEmail: false,
                erroTelefone: false,
                erroAssinatura: false
            },
            erroDocumento: false,
            mensagemErro: '',
            disableBtn: false,
            representante: {
                Guid: '',
                ClienteId: '',
                Nome: '',
                Email: '',
                Cargo: '',
                CpfCnpj: '',
                TipoDocumento: 'CPF', // Adicionado o campo de tipo de documento
                UsPerson: false,
                PoliticamenteExposta: false,
                ResponsavelLogin: false,
                Tipo: '',
                Telefone: '',
                Assinatura: ''
            }
        }
    },
    async mounted() {
        this.representante.ClienteId = this.user.ClienteId;
        await this.fetchConfiguracao(['Exibir pergunta - Responsável pelo login?']);
        await this.fetchConfiguracao(['Exibir cargo em representante']);

        this.exibirCargo = this.getConfiguracoes('Exibir cargo em representante')?.Valor == 'N' ? false : true;
        this.configuracaoResponsavelPorLogin = this.getConfiguracoes('Exibir pergunta - Responsável pelo login?')?.Valor == 'N' ? false : true;
    },
    watch: {
        editarRepresentante() {
            this.representante = this.editarRepresentante;
            
            if (!this.representante.TipoDocumento) {
                this.representante.TipoDocumento = 'CPF';
            }

            if(!this.configuracaoResponsavelPorLogin && this.representante){
                this.representante.ResponsavelLogin = false;
            }
        },
        showModalCreate(){
            if(!this.showModalCreate){
               this.limparObj();
            }
        }
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        onValidateTelefone({ name, valid }) {
            if (!this.telefoneValido) {
                this.telefoneValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneValido[name] = valid;
            }
        },
        validarEmail() {
            this.validarEmailGeneric(this.representante.Email, 'email', {
                obrigatorio: true,
            });
        },
        // Método para mudar o tipo de documento
        aoMudarTipoDocumento() {
            if (!this.representante) return;
            
            // Limpa o campo de documento quando o tipo muda
            this.$set(this.representante, 'CpfCnpj', '');
            this.erroDocumento = false;
            this.mensagemErro = '';
        },
        // Método para validar o documento
        validarDocumento() {
            if (!this.representante) return;
            
            if (this.representante.CpfCnpj) {
                const resultado = documentoUtils.validarDocumentoCompleto(
                    this.representante.CpfCnpj, 
                    this.representante.TipoDocumento || 'CPF'
                );
                this.erroDocumento = !resultado.valido;
                this.mensagemErro = resultado.mensagem;
                
                // Se o documento for inválido, volte o foco para o campo
                if (!resultado.valido) {
                    this.$nextTick(() => {
                        const inputElement = document.querySelector('input[v-model="representante.CpfCnpj"]');
                        if (inputElement) {
                            inputElement.focus();
                        }
                    });
                }
            } else {
                this.erroDocumento = false;
                this.mensagemErro = '';
            }
        },
        handleTipoChange() {
            if (this.representante && this.representante.Tipo === 'Pessoa autorizada emitir ordem') {
                this.representante.Assinatura = 1;
                this.representante.ResponsavelLogin = false;
            }
        },
        closeModal() {
            this.camposObrigatorios.erroTipo = false;
            this.camposObrigatorios.erroNome = false;
            this.camposObrigatorios.erroCpfCnpj = false;
            this.camposObrigatorios.erroCargo = false,
            this.camposObrigatorios.erroTipoDocumento = false;
            this.camposObrigatorios.erroEmail = false;
            this.camposObrigatorios.erroTelefone = false;
            this.camposObrigatorios.erroAssinatura = false;
            this.erroDocumento = false;
            this.mensagemErro = '';
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", { showModal: false, existeResponsavel: this.existeResponsavelLogin });
            this.$store.commit("SET_MODAL_PJ_EDITAR_PESSOA", this.representante);
        },
        limparObj() {
            this.representante = {
                Guid: '',
                ClienteId: this.user.ClienteId,
                Nome: '',
                Email: '',
                Cargo: '',
                CpfCnpj: '',
                TipoDocumento: 'CPF', // Inicializa com CPF
                UsPerson: false,
                PoliticamenteExposta: false,
                ResponsavelLogin: false,
                Tipo: '',
                Assinatura: ''
            };
            this.erroDocumento = false;
            this.mensagemErro = '';
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroTipo: false,
                erroNome: false,
                erroCpfCnpj: false,
                erroCargo: false,
                erroTipoDocumento: false,
                erroEmail: false,
                erroTelefone: false,
                erroAssinatura: false
            };
            
            if(this.representante){
                if (this.representante.Tipo === null || this.representante.Tipo === undefined || this.representante.Tipo === '') {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroTipo = true;
                        nomeDoCampo = 'Tipo';
                    }
                    this.permitirAvancar = false;
                }
                
                if (!this.representante.Nome) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroNome = true;
                        nomeDoCampo = 'Nome';
                    }
                    this.permitirAvancar = false;
                }

                if (!this.representante.Cargo && this.exibirCargo) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroCargo = true;
                        nomeDoCampo = 'Cargo';
                    }
                    this.permitirAvancar = false;
                }
                
                if (!this.representante.TipoDocumento) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroTipoDocumento = true;
                        nomeDoCampo = 'Tipo de Documento';
                    }
                    this.permitirAvancar = false;
                }
                
                if (!this.representante.CpfCnpj) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroCpfCnpj = true;
                        nomeDoCampo = 'CPF/CNPJ';
                    }
                    this.permitirAvancar = false;
                } else if (this.erroDocumento) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroCpfCnpj = true;
                        nomeDoCampo = this.obterLabelDocumento;
                    }
                    this.permitirAvancar = false;
                }
                
                if (Object.values(this.emailErros).some(erro => erro !== '')) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroEmail = true;
                        nomeDoCampo = 'E-mail';
                    }
                    this.permitirAvancar = false;
                }
                
                if (!this.representante.Telefone || !this.telefoneValido?.Telefone) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroTelefone = true;
                        nomeDoCampo = 'Telefone';
                    }
                    this.permitirAvancar = false;
                }
                
                
                if ((this.representante.Assinatura === null || this.representante.Assinatura === undefined || this.representante.Assinatura === '') && this.representante.Tipo !== 'Pessoa autorizada emitir ordem') {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroAssinatura = true;
                        nomeDoCampo = 'Assinatura';
                    }
                    this.permitirAvancar = false;
                }
            }
            
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
            return this.permitirAvancar;
        },
        // Restante dos métodos sem alteração
        async salvarRepresentante() {
            if (this.validarFormulario(true)) {
                this.disableBtn = true;
                if (this.representante && this.representante.Guid == '') {
                    await this.createRepresentante();
                } else {
                    await this.updateRepresentante();
                }
            }
        },
        async createRepresentante() {
             
            await api
                .post('/PessoaJuridica/representante/salvar', this.representante)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                            text: 'Dados informados foram salvos com sucesso.',
                        });
                        this.$emit('update-success'); 

                        this.limparObj();
                        this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", { showModal: false, existeResponsavel: this.existeResponsavelLogin });
                        this.$store.dispatch('FETCH_PJ_LISTA_REPRESENTANTES', this.user.ClienteId);
                        this.disableBtn = false;

                        return true;
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos informado para representante.',
                        text: `${error.response.data.data[0]}`,
                    }).then(() => {
                        return false;
                    });
                });
        },
        async updateRepresentante() {
             
            await api
                .post('/PessoaJuridica/representante/atualizar', this.representante)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Alteração realizada com sucesso!',
                            text: 'Dados informados foram atualizados com sucesso.',
                        });
                        this.$emit('update-success'); 

                        this.limparObj();
                        this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", { showModal: false, existeResponsavel: this.existeResponsavelLogin });
                        this.$store.dispatch('FETCH_PJ_LISTA_REPRESENTANTES', this.user.ClienteId);
                        this.disableBtn = false;

                        return true;
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos informado para representante.',
                        text: `${error.response.data.data[0]}`,
                    }).then(() => {
                        return false;
                    });
                });
        },
        // Método helper para salvar alterações
        salvarAlteracoesLocalmente() {
            // Implementação conforme necessário
            console.log('Alterações salvas localmente:', this.representante);
        },
        clear() {
            // Método existente
        }
    },
};
</script>

<style lang="scss" scoped>
@include modal;



/* Mobile Styles */
@media (max-width: 768px) {

    .modalRepresentantesPJ {
        .modal-close-btn {
            position: absolute !important;
            top: 10px !important;
            right: 15px !important;
            z-index: 10 !important;
            font-size: 20px !important;
            font-weight: bold !important;
            cursor: pointer !important;
            width: 24px !important;
            height: 24px !important;
            line-height: 22px !important;
            text-align: center !important;
            background: #f5f5f5 !important;
            border-radius: 50% !important;
        }


        .modal__mask {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 10px !important;
        }
        
        .modal__wrapper {
            display: block !important;
            width: 100% !important;
            margin: 0 auto !important;
        }
        
    .modal__container.reset {
        @media (max-width: 768px) {
            padding: 0px !important;
            width: 80% !important;
            height: auto !important;
            margin: 0 auto !important;
            border-radius: 8px !important;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
            position: relative !important;
            transform: scale(0.9) !important;
        }
    }
        
        .form__controls {
            width: 90% !important;
            margin-right: auto !important;
            margin-left: auto !important;
            margin-bottom: 15px !important;
        }
        
        .row {
            flex-direction: column !important;
            width: 95% !important;
            margin: 0 auto !important;
            align-items: center !important;

            @media (min-width: 769px) {
                width: 80% !important;
                margin-left: 20px !important;
            }
        }
        
        input.field, select.field {
            width: 95% !important;
            height: 40px !important;
            margin-bottom: 8px !important;
            box-sizing: border-box !important;
        }
        
        .label {
            display: block !important;
            margin-bottom: 5px !important;
            width: 100% !important;
        }
        
        .radio {
            width: 95% !important;
            margin-bottom: 10px !important;
            display: flex !important;
            flex-wrap: nowrap !important;
            align-items: center !important;
            justify-content: flex-start !important;
            
            input.field__radio {
                margin-right: 5px !important;
                margin-left: 0 !important;
            }
            
            input.field__radio_second {
                margin-left: 20px !important;
            }
            
            label {
                margin-right: 20px !important;
                white-space: nowrap !important;
            }
        }
    }
}

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

@media (max-width: 768px) {
    .field {
        padding: 6px 10px !important;
    }

    .buttonsAcoes {
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        width: 100% !important;
        margin: 20px auto !important;
        flex-wrap: nowrap !important;
    }

    .buttonsAcoes button {
        margin-top: 0px !important;
        flex: 1 !important;
        height: 40px !important;
        min-height: 40px !important;
        border-radius: 8px !important;
        font-size: 14px !important;
        padding: 0 15px !important;
    }
    
    .btnDefault {
        background-color: #f5f5f5 !important;
        border: 1px solid #ddd !important;
        color: #333 !important;
    }
    
    .btnBlue {
        background-color: #00235C !important;
        color: white !important;
        border: 1px solid #00235C !important;
    }
}


        .inner__modal{
            width: 80% !important;
             @media (max-width: 768px) {
                width: 100%  !important;
            }
        }






    @media (min-width: 769px){

        .inner__modal{
            height: 90vh !important;
        }
        .content__modal_representante {
            height: 95vh !important;
        }

        .btnBlue {
            background-color: #00235C !important;
            color: white !important;
            border: 1px solid #00235C !important;
        }

        button{
            height: 40px;
            font-family: "Inter", sans-serif; /* Fonte Inter */
            width: auto;
            border-radius: 8px; /* Raio de borda */
            cursor: pointer;
            font-weight: 500;
            padding: 5px 5px !important;
            font-size: smaller !important;
        }


        .modalRepresentantesPJ{
            height: 100% !important;
        }

        .modal__container {
            height: 100% !important; 
            margin: 20px auto;
            padding: 30px 20px !important;
            max-height: 80vh !important;
            margin: 10vh auto 10vh auto;
        }

        
    }
        
</style>